import TestimonyPage from "../../../components/Testimony/TestimonyPage";

const Testimony: React.FC = () => {
  return <TestimonyPage />;
};

export default Testimony;
